// extracted by mini-css-extract-plugin
module.exports = {"moduleWin":"styles_moduleWin__2rRPW"};